module.exports = __webpack_public_path__ + "static/media/lgpd.55601dd6.svg";